import { FC } from 'react';
import MuiButton, { ButtonProps } from '@mui/material/Button';
import CircularProgress, {
  CircularProgressProps,
} from '@mui/material/CircularProgress';

type Props = {
  loading?: boolean;
  progressProps?: CircularProgressProps;
} & ButtonProps;

const Button: FC<Props> = props => {
  const { loading = false, children, sx, progressProps, ...rest } = props;

  return (
    <MuiButton
      variant="contained"
      {...rest}
      sx={{
        minHeight: 40,
        ...sx,
      }}>
      {loading ? <CircularProgress {...progressProps} size={25} /> : children}
    </MuiButton>
  );
};

export default Button;
